import styled, { css } from 'styled-components';
import Box from '../../_shared/components/Box';

import Icon from '../../_shared/components/Icon';
import Label from '../../_shared/components/Label';
import { CardType } from '../../_shared/types/trade';
import isOmpPlatform from '../../_shared/utils/isOmpPlatform';

export const StyledTradeEmpty = styled(Box)`
  flex-direction: row;
  width: 100%;
  margin-bottom: 18px;
  background: ${({ theme }) => theme.COLORS.BASE};
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);

  ${() =>
    isOmpPlatform() &&
    css`
      box-shadow: unset;
      border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_110};
    `}
`;

export const StyledHeader = styled(Label.Bold)`
  margin-top: 31px;
  ${props =>
    props.variant === CardType.PLAIN &&
    css`
      margin-left: 24px;
    `};
`;

export const StyledContent = styled(Label)`
  margin-top: 12px;
  ${props =>
    props.variant === CardType.PLAIN &&
    css`
      margin: 12px 24px 31px;
    `};
`;

export const StyledIcon = styled(Icon).attrs({
  icon: 'TR5-NoResults'
})`
  width: 94.59px;
  height: 60px;
  margin: 24px;
`;
